import { render, staticRenderFns } from "./SecondaryCompanyLogo.vue?vue&type=template&id=05bcc0b4&scoped=true"
import script from "./SecondaryCompanyLogo.vue?vue&type=script&lang=js"
export * from "./SecondaryCompanyLogo.vue?vue&type=script&lang=js"
import style0 from "./SecondaryCompanyLogo.vue?vue&type=style&index=0&id=05bcc0b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bcc0b4",
  null
  
)

export default component.exports